import fetch from '../../fetch';
import environment from '../../../environment';
import { fetchBlob } from '../../fetchBlob';
import moment from 'moment';

const baseUrl = environment.get('API_HOST');

export class FuelStationStore {
    static listAllBrands = (): Promise<string[]> =>
        fetch({
            type: 'GET',
            url: `${baseUrl}/Layer/FuelStation/Brands`
        });

    static download = (data) => {
        return fetchBlob({
            fileName: `Neocom_Postos de Abastecimento Selecionados_v${moment().format('YYYYMMDD')}.xlsx`,
            url: `${environment.get('API_HOST')}/Layer/fuelstations/spreadsheet`,
            type: 'POST',
            parameters: data
        });
    }
}



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/fuelStation/index.js